export function appendReferrer() {
  const referrerCode = window.btoa(`${document.referrer} ${new Date().getTime()}`)
  return `referrer_code=${referrerCode}`
}
